import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, FieldArray } from 'redux-form';
import IconButton from 'material-ui/IconButton';
import KeyboardArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import KeyboardArrowUpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import { Checkbox } from 'redux-form-material-ui';
import _ from 'lodash';

import Details from './Details';
import { changePort } from 'actions/regions/ports';

const styles = {
    checkbox: {
        labelStyle: { fontSize: '14px' },
        style: { width: '750px' },
    },
    icon: {
        iconStyle: { color: '#00bcd4' },
    },
};

const LiftAndCranesItem = ({ liftCrane, liftsCranes, changePort }) => {
    const [showDetails, setShowDetails] = React.useState(false);

    const toggleDetails = React.useCallback(() => {
        setShowDetails(prev => !prev);
    }, []);

    const handleChangeVal = React.useCallback((_i, val, __i, name) => {
        if (!val) {
            const key = name.split('.')[1];
            const _liftsCranes = _.cloneDeep(liftsCranes);

            const updatedCrane = {
                ..._liftsCranes[key],
                checked: false,
                details: [],
            };

            changePort({
                liftsCranes: {
                    ..._liftsCranes,
                    [key]: updatedCrane,
                },
            });
        }
    }, [liftsCranes, changePort]);

    const { min, max } = React.useMemo(() => {
        if (!liftCrane.name) return { min: 0, max: 100 };
        const [minStr, maxStr] = liftCrane.name.split('-');
        return {
            min: parseInt(minStr) || 0,
            max: parseInt(maxStr) || 100,
        };
    }, [liftCrane.name]);

    return (
        <React.Fragment>
            <div className='line-head'>
                <div className='row'>
                    <div className='col-xs-12 middle-xs'>
                        <Field
                            component={Checkbox}
                            name={`liftsCranes.${liftCrane.name}.checked`}
                            label={liftCrane.label}
                            labelStyle={styles.checkbox.labelStyle}
                            style={styles.checkbox.style}
                            onChange={handleChangeVal}
                        />

                        <div 
                            className={liftCrane.checked ? 'more' : 'hidden more'} 
                            onClick={toggleDetails}
                        >
                            More details
                        </div>

                        {liftCrane.checked && (
                            <IconButton
                                iconStyle={styles.icon.iconStyle}
                                onClick={toggleDetails}
                            >
                                {showDetails ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        )}
                    </div>
                </div>
            </div>

            <div className={showDetails && liftCrane.checked ? 'line-body' : 'hidden'}>
                <FieldArray
                    name={`liftsCranes.${liftCrane.name}.details`}
                    component={Details}
                    props={liftCrane}
                    min={min}
                    max={max}
                />
            </div>
        </React.Fragment>
    );
};

LiftAndCranesItem.propTypes = {
    liftCrane: PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        checked: PropTypes.bool,
        details: PropTypes.array,
    }).isRequired,
    liftsCranes: PropTypes.object.isRequired,
    changePort: PropTypes.func.isRequired,
};

export default connect(
    (state, ownProps) => ({
        liftCrane: ownProps.liftCrane,
        liftsCranes: ownProps.liftsCranes,
    }),
    {
        changePort,
    },
)(LiftAndCranesItem);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/LiftAndCranes/Item.jsx